import { scrollToDashboardSection } from '@/lib/dashboard-sections';
import { useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';

export function useScrollToSection(sectionId: string) {
  const hash = useRouterState({ select: (state) => state.location.hash });

  useEffect(() => {
    const normalizedHash = hash.replace(/^#/, '');
    if (normalizedHash !== sectionId) return;

    scrollToDashboardSection(sectionId);
  }, [hash, sectionId]);
}
